<section class="faq" id="faq" aria-labelledby="faq-title">
  <div class="faq__inner">
    <div class="faq__intro">
      <p class="faq__eyebrow">FAQ</p>

      <h2 id="faq-title" class="faq__title">
        <span class="faq__title-line">Questions, answered</span>
        <span class="faq__title-line">clearly.</span>
      </h2>

      <p class="faq__text">
        Everything you need to know before benchmarking your model.
      </p>
    </div>

    <ul class="faq__list">
      <li class="faq__item" *ngFor="let faq of faqs" [class.faq__item--open]="faq.isExpanded">
        <button
          type="button"
          class="faq__question"
          (click)="toggleFaq(faq.id)"
          [attr.aria-expanded]="faq.isExpanded"
        >
          <span class="faq__question-text">{{ faq.question }}</span>
          <span class="faq__question-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path
                d="m6 9 6 6 6-6"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </button>

        <p class="faq__answer" *ngIf="faq.isExpanded">{{ faq.answer }}</p>
      </li>
    </ul>
  </div>
</section>
